export default "__VITE_ASSET__BYRRhRna__";